import React from 'react';

import clsx from 'clsx';

import TableHead from 'components/Table/TableHead/TableHead';
import TableHeadCell from 'components/Table/TableHeadCell/TableHeadCell';
import TableBody from 'components/Table/TableBody/TableBody';
import Table from 'components/Table/Table';
import TableRow from 'components/Table/TableRow/TableRow';
import TableBodyCell from 'components/Table/TableBodyCell/TableBodyCell';
import { Button } from 'components/Buttons/Button';
import { maskMonetaryValue } from 'prequalificationV2/utils/stringUtils';
import { OFFERS_TABLE_COLUMNS } from 'prequalificationV2/components/Offers/OffersTableWrapper/offersTableWrapper.constants';
import { OffersPageFilters } from 'prequalificationV2/components/Offers/OffersTableWrapper/offersTableWrapper.types';
import OfferRowLabel from 'prequalificationV2/components/Offers/OffersTableWrapper/OfferRowLabel/OfferRowLabel';
import { OfferDto } from 'api/OffersApi';

import styles from './OffersTable.module.scss';

export interface OffersTableProps {
  offers: OfferDto[];
  onAcceptOffer: (loanOffer: OfferDto) => void;
  isDisabled: boolean;
  filters: OffersPageFilters;
  updateTableSort: (sortField?: keyof OfferDto) => void;
}

const OffersTable = ({ onAcceptOffer, isDisabled, filters, updateTableSort, offers }: OffersTableProps) => {
  return (
    <Table className={styles.table}>
      <TableHead className={clsx(styles.tableRowTemplate, styles.tableHead)}>
        {OFFERS_TABLE_COLUMNS.map((column) => (
          <TableHeadCell
            key={column.title}
            className={clsx(styles.tableHeadCell, {
              [styles.tableHeadCellSorted]: filters.sortField === column.sortField,
            })}
            isExist={column.isExist}
            isSorted={!!column.sortField}
            currentSort={filters.sortField === column.sortField}
            isSortedDesc={filters.isSortDesc}
            onClick={() => updateTableSort(column.sortField)}
          >
            {column.title}
          </TableHeadCell>
        ))}
      </TableHead>
      <TableBody>
        {offers.map((offer: OfferDto, index) => (
          <TableRow key={index} className={clsx(styles.tableRowTemplate, styles.tableRow)}>
            <TableBodyCell className={styles.tableBodyCell}>{offer.term} years</TableBodyCell>
            <TableBodyCell className={styles.tableBodyCell}>{offer.rate}%</TableBodyCell>
            <TableBodyCell className={styles.tableBodyCell}>{offer.apr}%</TableBodyCell>
            <TableBodyCell className={styles.tableBodyCell}>
              {maskMonetaryValue(offer.monthlyPayment?.toFixed(2))}
            </TableBodyCell>
            <TableBodyCell className={styles.tableBodyCell}>
              <Button className={styles.acceptButton} disabled={isDisabled} onClick={() => onAcceptOffer(offer)}>
                Accept
              </Button>
            </TableBodyCell>
            <OfferRowLabel offer={offer} />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default OffersTable;
